import { Component, OnInit } from '@angular/core';
import { environment } from "environments/environment";
import { appVersionDetails } from "app/appVersionDetails";

@Component({
	selector: 'app-footer',
	templateUrl: './footer.component.html',
	styleUrls: ['./footer.component.css']
})
export class FooterComponent implements OnInit {

    Now: Date = new Date();
    AppVersion: string = appVersionDetails.FullSemVer;


	constructor() { }

	ngOnInit() {
	}

}



// WEBPACK FOOTER //
// ./src/app/shared/footer/footer.component.ts